
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/blogchain/2022/3-reasons-kadena-is-the-right-choice-for-crypto-builders-and-miners-2022-07-08",
      function () {
        return require("private-next-pages/docs/blogchain/2022/3-reasons-kadena-is-the-right-choice-for-crypto-builders-and-miners-2022-07-08.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/blogchain/2022/3-reasons-kadena-is-the-right-choice-for-crypto-builders-and-miners-2022-07-08"])
      });
    }
  